import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Auth } from '@aws-amplify/auth';
import { Observable, from, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { PampClinicConfig } from '../models/pamp-clinic-config.model';

@Injectable({ providedIn: 'root' })
export class PampClinicConfigService {
  private apiUrl = environment.pampClinicSetupAPIEndpoints;

  constructor(private http: HttpClient) {}

  /** Get JWT token from Cognito session */
  private getIdToken(): Observable<string> {
    return from(Auth.currentSession()).pipe(
      switchMap((session: any) => {
        const token = session.getIdToken().getJwtToken();
        if (!token) throw new Error('No ID token found');
        return of(token);
      })
    );
  }

  /** Get a single clinic configuration by ID */
  getPampClinicConfig(clinicId: string): Observable<PampClinicConfig> {
    return this.getIdToken().pipe(
      switchMap((token) => {
        return this.http.get<PampClinicConfig>(`${this.apiUrl}/${clinicId}`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        });
      })
    );
  }
}
